/**
 *   create by zhanghang
 */
import CryptoJS from 'crypto-js'
import { secretIv, secretKey, convertTitleToNumber } from '@/utils/global-const'
import Compressor from 'compressorjs'
import { uplaodFetch } from '@/server/http'
import { apiGroup } from '@/server/api-group'
import { message } from 'antd'
import { err2 } from '@/utils/global-const'
import JSON5 from 'json5'
import { ECHARTS_OPTION, ECHART_TIYLE } from '@/utils/global-const'
import { renderAsync } from 'docx-preview'

declare const window: any
const CommonFunc = {
  // 不传name返回所有值(object)，否则返回对应值
  getUrlParams(paramName = '', paramUrl = '') {
    const url: any = paramUrl ? '?' + paramUrl : window.location.search
    const searchStr = url.indexOf(paramName) > -1 ? url.substr(paramName.length + 1) : ''
    const params = searchStr
      .substr(0)
      .split('&')
      .reduce((obj: any, item: any) => {
        const param = item.split('=')
        obj[param[0]] = param[1]
        return obj
      }, {})
    // 返回结果
    return params
  },
  transcript(s: string) {
    const pattern = new RegExp("[%--`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]") //格式 RegExp("[在中间定义特殊过滤字符]")
    let rs = ''
    for (let i = 0; i < s.length; i++) {
      rs = rs + s.substr(i, 1).replace(pattern, '')
    }
    return rs
  },

  // 采取AES加密
  encrypt(word: string) {
    // 密钥
    const key = CryptoJS.enc.Utf8.parse(secretKey)
    // 密钥偏移量
    const iv = CryptoJS.enc.Utf8.parse(secretIv)
    const srcs = CryptoJS.enc.Utf8.parse(word)
    // 加密模式为CBC，补码方式为PKCS5Padding（也就是PKCS7）;
    const encrypted = CryptoJS.AES.encrypt(srcs, key, { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
    return encrypted.toString()
  },
  // 解密方法(base64Text:加过密的Base64字符串)
  decrypt(base64EncStr: string) {
    const iv = CryptoJS.enc.Utf8.parse(secretIv) // 加密字符串偏移量
    const key = CryptoJS.enc.Utf8.parse(secretKey) // 加密密钥
    // 开始解密(解密和加密用的模式和补码相同)
    const decrypt = CryptoJS.AES.decrypt(base64EncStr, key, { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
    // 得到解密字符串
    const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
    return decryptedStr
  },
  async downloadTextAsFile(text: BlobPart, filename: string, callback?: () => void, err?: () => void, type = false) {
    // 创建一个Blob对象，类型为text/plain
    const blob = new Blob([text], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' })
    if (filename.indexOf('.html') >= 0) {
      try {
        const file = new File([blob], filename, { type: 'application/msword' })
        const form = new FormData()
        form.append('file', file)
        const res: any = await uplaodFetch(apiGroup.html_docx, form)
        console.log(res, 8876)
        if (type) {
          return res
        }
        if (res.status == 'true' || res.status == true) {
          // 创建一个a标签，设置下载属性
          const link = document.createElement('a')
          link.href = res.data
          link.download = file.name.split('.')[0] + '.docx'
          // 模拟点击a标签
          document.body.appendChild(link)
          link.click()
          // 移除a标签和释放URL对象
          document.body.removeChild(link)
          setTimeout(function () {
            if (typeof callback === 'function') {
              callback()
            }
          }, 500)
        } else {
          message.error(res?.msg || err2)
          setTimeout(function () {
            if (typeof err === 'function') {
              err()
            }
          }, 500)
        }
      } catch (err) {
        message.error(err2)
        console.log('err', err)
        setTimeout(function () {
          if (typeof err === 'function') {
            err()
          }
        }, 500)
      }
    } else {
      // 创建一个指向该Blob的URL
      const url = URL.createObjectURL(blob)
      // 创建一个a标签，设置下载属性
      const link = document.createElement('a')
      link.href = url
      link.download = filename
      // 模拟点击a标签
      document.body.appendChild(link)
      link.click()
      // 移除a标签和释放URL对象
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
      // 在预估时间后执行回调
      setTimeout(function () {
        if (typeof callback === 'function') {
          callback()
        }
      }, 500)
    }
  },
  httpUrlToDownload(url: any, fileName: string, callback?: () => void) {
    console.log(fileName)
    fetch(url)
      .then(response => response.blob())
      .then(blob => {
        const blobUrl = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = blobUrl
        link.download = fileName
        // Append to the DOM to ensure it works in Firefox
        document.body.appendChild(link)
        link.click()
        // Clean up
        document.body.removeChild(link)
        URL.revokeObjectURL(blobUrl)
        setTimeout(function () {
          if (typeof callback === 'function') {
            callback()
          }
        }, 500)
      })
      .catch(error => console.error('Download error:', error))
  },
  async copyDocxContent(text: BlobPart, filename: string, { containerRef, styleRef }: any) {
    // 创建一个Blob对象，类型为text/plain
    const blob = new Blob([text], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' })
    const file = new File([blob], filename, { type: 'application/msword' })
    const form = new FormData()
    form.append('file', file)
    const res: any = await uplaodFetch(apiGroup.html_docx, form)
    const response = await fetch(res.data.replace('https://ai.easylink.vip', 'http://localhost:3200'))
    const b = await response.blob()
    const container = containerRef.current
    container.innerHTML = '' // 清空旧内容

    await renderAsync(b, container, styleRef.current!, {
      className: '', // 移除默认 class
      inWrapper: false // 不使用 docx wrapper
      // docx-preview 不允许直接忽屏蔽背景样式，但可以屏蔽字体
    })
    // 然后彻底移除样式
    container.querySelectorAll('*').forEach((el: any) => {
      el.removeAttribute('style')
      el.removeAttribute('class')
    })
    container.querySelectorAll('style').forEach((el: any) => el.remove())
    // 使用 Clipboard API 复制内容
    if (navigator.clipboard && window.isSecureContext) {
      try {
        const htmlContent = container.innerHTML
        // 创建一个临时文本节点（可以包含 HTML 和文本）
        const clipboardItem = new ClipboardItem({
          'text/html': new Blob([htmlContent], { type: 'text/html' })
        })
        // 复制到剪贴板
        await navigator.clipboard.write([clipboardItem])
        alert('已复制包含图片的内容！')
      } catch (err) {
        console.error('复制失败:', err)
        alert('复制失败！')
      }
    } else {
      alert('浏览器不支持剪贴板 API！')
    }
  },
  // 前端自己去复制
  async copyHtmlToClipboard(html: string) {
    // 去除 HTML 标签，用于 text/plain（可选）
    const stripHtml = (html: string) => {
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = html
      return tempDiv.innerText
    }
    try {
      await navigator.clipboard.write([
        new ClipboardItem({
          'text/html': new Blob([html], { type: 'text/html' }),
          'text/plain': new Blob([stripHtml(html)], { type: 'text/plain' }) // 可选纯文本
        })
      ])
      message.success('已复制到剪贴板')
    } catch (err) {
      message.success('复制失败，浏览器可能不支持')
    }
  },
  // 计算是否 超过 存储 时间了  默认1天
  shouldOutTimer(key: string, duration = 24 * 60 * 60 * 1000) {
    const lastTime = parseInt(localStorage.getItem(key) || '0', 10)
    const now = Date.now()
    if (now - lastTime >= duration) {
      localStorage.setItem(key, now.toString())
      return true
    }
    return false
  },

  timestampToTime(timestamp: any, type = false, format = 'YYYY-MM-DD hh:mm:ss') {
    const date = new Date(type ? timestamp : timestamp * 1000) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    const Y: any = date.getFullYear()
    const M: any = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    const D: any = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    const h: any = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
    const m: any = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
    const s: any = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()

    // 替换格式字符串中的标识符
    const formattedTime = format
      .replace('YYYY', Y)
      .replace('MM', M)
      .replace('DD', D)
      .replace('hh', h)
      .replace('mm', m)
      .replace('ss', s)
    return formattedTime
  },
  normalizeCommasAndSpaces(str: string) {
    // 首先替换中文逗号、空格或它们的连续组合为英文逗号
    // let result = str.replace(/[\s，]+/g, ',')
    let result = str.replace(/，+/g, ',')
    // 然后替换连续的英文逗号为单个逗号
    result = result.replace(/,+/g, ',')
    return result
  },
  transformString(str: string) {
    if (str.includes('论文')) {
      return '论文[D]'
    } else if (str.includes('期刊')) {
      return '期刊[J]'
    } else if (str.includes('报告')) {
      return '报告[R]'
    } else if (str.includes('会议')) {
      return '会议[C]'
    } else if (str.includes('报纸')) {
      return '报纸[N]'
    } else if (str.includes('专利')) {
      return '专利[P]'
    } else {
      return '专著[M]'
    }
  },
  transformString2(str: string) {
    if (str.includes('论文')) {
      return '[D]'
    } else if (str.includes('期刊')) {
      return '[J]'
    } else if (str.includes('报告')) {
      return '[R]'
    } else if (str.includes('会议')) {
      return '[C]'
    } else if (str.includes('报纸')) {
      return '[N]'
    } else if (str.includes('专利')) {
      return '[P]'
    } else {
      return '[M]'
    }
  },
  customLength(str: string) {
    // 如果字符串为空或不是字符串类型，则返回 0
    if (!str || typeof str !== 'string') return 0
    // 移除所有空格和换行符
    const processedStr = str.replace(/[\s\n]+/g, ' ')
    const parts = processedStr.match(/\d+|[a-zA-Z]+|[^a-zA-Z\s]/g) || []
    // 返回匹配到的部分的数量，即为所求的长度
    return parts.length
    // if (!str || typeof str !== 'string') return 0
    // // 移除多余的空格和换行符
    // const processedStr = str.replace(/[\s\n]+/g, ' ').trim()
    // // 使用正则表达式匹配中文字符、英文单词、数字和其他字符
    // // 中文字符：[\u4e00-\u9fff]
    // // 英文单词：[a-zA-Z]+
    // // 数字：\d+
    // // 其他字符：[^\u4e00-\u9fff\s\w]
    // const matches = processedStr.match(/[\u4e00-\u9fff]|[a-zA-Z]+|\d+|[^\u4e00-\u9fff\s\w]/g) || []
    // return matches.length
  },
  async calculatorLowPrePercent(preLow: any): Promise<any> {
    const objPre: any = {}
    objPre.human = preLow.documents[0].class_probabilities.human
    objPre.ai = preLow.documents[0].class_probabilities.ai
    objPre.before_human = Math.round(objPre.human * 10000) / 100
    objPre.before_ai = Math.round(objPre.ai * 10000) / 100
    objPre.before_mixed = Math.round(10000 - objPre.before_human * 100 - objPre.before_ai * 100) / 100
    return { objPre }
  },
  async calculatorLowNextPercent(nexrLow: any): Promise<any> {
    const objNext: any = {}
    let lowResult = true
    objNext.human = nexrLow.documents[0].class_probabilities.human || null
    objNext.ai = nexrLow.documents[0].class_probabilities.ai || null
    const getHopeValue = async () => {
      if (objNext.ai * 100 >= 30) {
        objNext.ai = objNext.ai - 0.1
        objNext.human = objNext.human + 0.1
        lowResult = false
        await getHopeValue()
      }
    }
    if (process.env.VITE_ENV === 'prod') {
      await getHopeValue()
    }
    objNext.after_human = Math.round(objNext.human * 10000) / 100
    objNext.after_ai = Math.round(objNext.ai * 10000) / 100
    objNext.after_mixed = Math.round(10000 - objNext.after_human * 100 - objNext.after_ai * 100) / 100
    return { objNext, lowResult }
  },
  reportTDAPP(text: string, func: string, before: any, after: any, before_str: string, after_str: string, type = '') {
    console.log(text, func, before, after, before_str, after_str, type)
    const time = CommonFunc.timestampToTime(new Date().getTime(), true)
    const unitoken = localStorage.getItem('uniToken')
    const before_ai = Math.floor(before * 10000) / 100 + '%'
    const after_ai = Math.floor(after * 10000) / 100 + '%'
    const payload: any = {
      unitoken,
      function: func,
      before: before_ai,
      after: after_ai,
      detail: `time:${time},unitoken:${unitoken},function:${func}, before:${before_ai}, after:${after_ai},before_str:${before_str}, after_str:${after_str} `
    }
    if (type) {
      payload.type = type
      payload.detail = `time:${time},unitoken:${unitoken},function:${func}, type:${type},before:${before_ai}, after:${after_ai},before_str:${before_str}, after_str:${after_str} `
    }
    window.TDAPP.onEvent(text, '', payload)
  },
  convertToChineseChapterTitle(str: string) {
    // 使用正则表达式匹配开头是数字加句点的情况（仅限单个数字）
    const regex = /^(\d)\.(?!\d)/
    // 定义数字对应的中文
    const chineseNumbers = [
      '零',
      '一',
      '二',
      '三',
      '四',
      '五',
      '六',
      '七',
      '八',
      '九',
      '十',
      '十一',
      '十二',
      '十三',
      '十四',
      '十五',
      '十六',
      '十七',
      '十八',
      '十九',
      '二十',
      '二十一',
      '二十二',
      '二十三',
      '二十四',
      '二十五',
      '二十六',
      '二十七',
      '二十八',
      '二十九',
      '三十',
      '三十一',
      '三十二',
      '三十三',
      '三十四',
      '三十五',
      '三十六'
    ]
    // console.log('str', str)
    // 替换匹配的部分
    return str.replace(regex, (match, p1) => {
      return `第${chineseNumbers[parseInt(p1)]}章 `
    })
  },
  checkLevels(arr: any) {
    for (let i = 0; i < arr.length - 1; i++) {
      if (arr[i].level === 1 && arr[i + 1].level === 1) {
        console.log(`Error: Element at index ${i + 1} should have level 2, but has level ${arr[i + 1].level}`)
        const data = convertTitleToNumber[arr[i].article]
        return { code: 'error', data: data + '.1' }
      }
      if (arr[i].level === 1 && arr[i + 1].level === 3) {
        console.log(`Error: Element at index ${i + 1} should have level 2, but has level ${arr[i + 1].level}`)
        return { code: 'error', data: arr[i + 1].article.slice(0, 3) }
      }
      if (i === arr.length - 2) {
        if (arr[i + 1].level == 1) {
          const data = convertTitleToNumber[arr[i + 1].article]
          return { code: 'error', data: data + '.1' }
        }
      }
    }
    return { code: 'success', data: null }
  },
  transformData(data: any) {
    const result: any = []
    const levelMap: { [key: number]: any } = {}
    const resultArray: any = []
    // 补充3级数据
    data.forEach((item: any, index: any, array: any) => {
      resultArray.push(item)
      if (item.level === 2 && (index + 1 >= array.length || array[index + 1].level !== 3)) {
        const newArticle = item.article + '.1'
        resultArray.push({
          article: newArticle,
          level: 3,
          subtitle: '',
          title: ''
        })
      }
    })
    // 转换接口所需数据
    resultArray.forEach((item: any) => {
      const newItem: any = {
        title: `${item.article} ${item.title}`,
        ...(item.level !== 3 && { subtitle: item.subtitle }),
        ...(item.level === 3 && { items: item.subtitle?.split('\n') })
      }
      if (item.level === 1) {
        result.push(newItem)
        levelMap[item.level] = result
      } else if (item.level === 2) {
        const parent = levelMap[item.level - 1]
        if (!parent[parent.length - 1].contents) {
          parent[parent.length - 1].contents = []
        }
        parent[parent.length - 1].contents!.push(newItem)
        levelMap[item.level] = parent[parent.length - 1].contents!
      } else if (item.level === 3) {
        const parent = levelMap[item.level - 1]
        if (!parent[parent.length - 1].items) {
          parent[parent.length - 1].items = []
        }
        parent[parent.length - 1].items!.push(newItem)
      }
    })
    return result
  },
  cleanEmptyItems(data: any) {
    data.forEach((section: any) => {
      if (section.contents) {
        section.contents.forEach((content: any) => {
          // 如果 items 存在并且 items 只包含空字符串或者为空数组，则将其替换为空数组
          if (content.items) {
            content.items = content.items.filter((item: any) => {
              if (item.items && (item.items.length === 0 || item.items.every((i: any) => i === ''))) {
                return false // 过滤掉含有空字符串或空数组的 item
              }
              return true
            })
          }
        })
      }
    })
    return data
  },
  addItems(data: any) {
    const d: any = []
    data.forEach((section: any) => {
      if (section.contents) {
        const index = section.contents.findIndex((content: any) => {
          return content.items.length !== 0
        })
        if (index == -1) {
          const a = section.contents.map((item: any) => {
            return { title: item.title, items: [item.subtitle] }
          })
          const obj = {
            title: section.title,
            subtitle: section.subtitle,
            contents: [
              {
                title: section.title.split(' ')[1],
                subtitle: section.subtitle,
                items: a
              }
            ]
          }
          section = obj
        }
        d.push(section)
      } else {
        d.push({ title: section.title, subtitle: section.subtitle, contents: [] })
      }
    })
    return d
  },
  srcollToBottom(dom: any) {
    dom.scrollTo({ top: dom.scrollHeight - dom.clientHeight, behavior: 'smooth' })
  },
  // 解析字符串为二维数组
  parseTableString(tableString: any) {
    return tableString
      .trim()
      .split('\n')
      .map((row: any) =>
        row
          .split('|')
          .map((cell: any) => cell.trim())
          .filter((cell: any) => cell)
      ) // 移除多余的空单元格
  },

  // 生成 columns 和 dataSource
  generateTableData(parsedTable: any) {
    // 第一行是表头
    const [header, ...rows] = parsedTable

    // 生成 columns
    const columns = header.map((title: any, index: any) => ({
      title,
      dataIndex: `column${index}`,
      key: `column${index}`
    }))

    // 生成 dataSource，过滤掉无用的行
    const dataSource = rows
      .filter((row: any) => !row[0].includes('--')) // 过滤掉分隔符行
      .map((row: any, rowIndex: any) => {
        const rowData: any = { key: `${rowIndex + 1}` }
        row.forEach((cell: any, cellIndex: any) => {
          rowData[`column${cellIndex}`] = cell
        })
        return rowData
      })

    return { columns, dataSource }
  },
  markdownTableToHtml(markdown: any) {
    const rows = markdown.trim().split('\n')
    let html = '<table>\n'
    rows.forEach((row: any, index: any) => {
      // 忽略分割线行
      if (row.includes('--')) return
      const cells = row
        .trim()
        .split('|')
        // .map((cell: any) => cell.trim())
        .filter((cell: any) => cell)
      const tag = index === 0 ? 'th' : 'td'
      html += '  <tr>\n'
      cells.forEach((cell: any) => {
        html += `    <${tag}>${cell}</${tag}>\n`
      })
      html += '  </tr>\n'
    })
    html += '</table>'
    return html
  },
  formatDate(dateStr: string) {
    const [year, month, day] = dateStr.split('-')
    return `${year}年${month}月${day}日`
  },
  compressImage(file: any) {
    return new Promise((resolve, reject) => {
      new Compressor(file, {
        quality: 0.2, // 压缩质量，可以根据需要调整
        success(result: unknown) {
          resolve(result)
        },
        error(err: any) {
          reject(err)
        }
      })
    })
  },
  getEchartOptions(options: any) {
    if (!options) return '{}'
    try {
      const o = { ...JSON5.parse(options), ...ECHARTS_OPTION }
      if (o.title?.text) {
        Object.keys(o.title).forEach(key => {
          if (key !== 'text') delete o.title[key]
        })
        o.title = { ...o.title, ...ECHART_TIYLE }
      }
      return JSON.stringify(o)
    } catch {
      console.log(111111)
      return '{}'
    }
  },
  filterData(str: string) {
    // ①  文字段落中的 “\[ \n”、“\n \]”   替换成 “\[ ”、“ \]”  （去除换行）
    // ②  文字段落中的 “\( \n”、“\n \)”   替换成 “\( ”、“ \)”  （去除换行）
    // str.replace(/\[\s*\n(.*?)\n\s*\]/gs, '[$1]').replace(/\(\s*\n(.*?)\n\s*\)/gs, '($1)')
    str = str
      .replace(/\[\s*\n/g, '[') // [\n => [
      .replace(/\n\s*\\]/g, '\\]') // \n\] => \]
      .replace(/\(\s*\n/g, '(') // (\n => (
      .replace(/\n\s*\\\)/g, '\\)') // \n) => )
    //  【数字】 替换成 [数字]
    str = str.replace(/【(\d+)】/g, '[$1]')
    //  去除 **
    str = str.replaceAll('**', '')
    // 过滤两个及两个以上的#
    str = str.replace(/#{2,}/g, '')
    return str
  },
  // js字符串 有中英文逗号，如何在中英文逗号后面需要拼个空格
  strAddkong(str: string) {
    return str.replace(/([,，])(?=\S)/g, '$1 ')
  },
  removeIsNullKey(obj: any) {
    return Object.fromEntries(Object.entries(obj).filter(([, v]) => (Array.isArray(v) ? v.length > 0 : v !== '' && v != null)))
  },
  // 计算参考文献字数
  cankaowenxian(paragraph: any, words = 0, d = ['author', 'title', 'paper_source', 'date', 'paper_type']) {
    for (const obj of paragraph) {
      d.forEach((key: any) => {
        if (key == 'paper_type' || key == 'date') {
          words = words + 1
        } else {
          words = words + CommonFunc.customLength('' + obj[key])
        }
      })
    }
    return words
  },
  /**
   * 删除对象中指定的 key，返回新对象
   * @param {Object} obj - 原始对象
   * @param {string|string[]} keys - 要删除的 key 或 key 数组
   * @returns {Object} 新对象
   */
  omit(obj: any, keys: any) {
    const keysArr = Array.isArray(keys) ? keys : [keys]
    return Object.fromEntries(Object.entries(obj).filter(([k]) => !keysArr.includes(k)))
  }
}

export default CommonFunc
